import Brightness4Icon from '@mui/icons-material/Brightness4';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { AppBar, Avatar, Box, IconButton, Menu, MenuItem, Stack, Toolbar, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
const Header = ({ onToggleSidebar, open }: { onToggleSidebar: () => void; open: boolean }) => {
  const [anchorNotif, setAnchorNotif] = useState<null | HTMLElement>(null);
  const [anchorProfile, setAnchorProfile] = useState<null | HTMLElement>(null);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleNotifOpen = (event: React.MouseEvent<HTMLElement>) => setAnchorNotif(event.currentTarget);
  const handleNotifClose = () => setAnchorNotif(null);

  const handleProfileOpen = (event: React.MouseEvent<HTMLElement>) => setAnchorProfile(event.currentTarget);
  const handleProfileClose = () => setAnchorProfile(null);

  const handleLogout = () => {
    logout();
    handleProfileClose();
    navigate('/');
  };

  return (
    <AppBar position="fixed" sx={{ background: '#131A21', boxShadow: 'none' }}>
      <Toolbar>
        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
          <Stack direction="row" alignItems="center" width="10%" sx={{
            marginLeft: open ? '280px' : '64px'
          }}>
            <IconButton color="inherit" edge="start" onClick={onToggleSidebar} sx={{ mr: 2, borderRadius: 2, background: '#181F2A', p: 1 }}>
              <img src="/icons/menu-icon.svg" alt="logo" width={32} height={32} />
            </IconButton>
          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="flex-end" width="20%" spacing={1}>
            <IconButton color="inherit" sx={{ borderRadius: 2, background: '#181F2A'}}>
              <Brightness4Icon />
            </IconButton>
            <Tooltip title="Notifications">
              <IconButton color="inherit" onClick={handleNotifOpen} sx={{ borderRadius: 2, background: '#181F2A'}}>
                <NotificationsIcon />
              </IconButton>
            </Tooltip>
            <Menu anchorEl={anchorNotif} open={Boolean(anchorNotif)} onClose={handleNotifClose}>
              <MenuItem onClick={handleNotifClose}>No new notifications</MenuItem>
            </Menu>
            <Tooltip title="Profile">
              <IconButton color="inherit" onClick={handleProfileOpen} sx={{ borderRadius: 2, background: '#181F2A', display: 'flex', alignItems: 'center', px: 1.5 }}>
                <Avatar alt={user?.name || 'User'} src="/static/images/avatar/1.jpg" sx={{ width: 32, height: 32, mr: 1 }} />
                {user?.name && (
                  <Box sx={{ display: { xs: 'none', md: 'flex' }, flexDirection: 'column', alignItems: 'flex-start' }}>
                    <Typography sx={{ fontWeight: 600, fontSize: 15, color: '#fff', lineHeight: 1 }}>{user.name}</Typography>
                    <Typography sx={{ fontSize: 12, color: '#b0b8c1', lineHeight: 1 }}>Guest</Typography>
                  </Box>
                )}
              </IconButton>
            </Tooltip>
            <Menu anchorEl={anchorProfile} open={Boolean(anchorProfile)} onClose={handleProfileClose} sx={{ mt: 1 }}>
              <MenuItem onClick={handleProfileClose}>Profile</MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default Header; 